import ActionType from '../actionTypes/graphicUploadActionType';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import { Dispatch } from 'redux';
import * as actions from './index';
import SnackBarType from '../../objects/app/snackbar';
import { useTranslation } from 'react-i18next';

const graphicUploadDelete = (uploadId: string, uploadBulkId: number) => async (
    dispatch: Dispatch
): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.GRAPHIC_UPLOAD_DELETE(
        uploadId,
        uploadBulkId.toString()
    );
    const { t } = useTranslation();
    const actionTypes = ActionType.graphicUploadDelete;

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        null,
        'get',
        {},
        {},
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    t('Graphic deleted successfully.'),
                    SnackBarType.SUCCESS,
                    false
                )
            );
        }
    );
};

const graphicUploadSubmit = (
    uploadIds: string[],
    uploadBulkId: number
    // onSubmit,
    // allFilesToRemove
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.GRAPHIC_UPLOAD_SUBMIT(
        uploadIds,
        uploadBulkId.toString()
    );
    const actionTypes = ActionType.graphicUploadSubmit;

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        null,
        'get',
        {},
        {},
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    'Graphics uploaded successfully..',
                    SnackBarType.SUCCESS,
                    false
                )
            );
        }
    );
};

const graphicUploadSubmitReset = () => (dispatch: Dispatch) => {
    dispatch({
        type: ActionType.graphicUploadSubmit.reset,
    });
};

const graphicUploadSetFileCount = (fileCount: number) => (
    dispatch: Dispatch
) => {
    dispatch({
        type: ActionType.graphicUploadSubmit.setFileCount,
        fileCount,
    });
};

const graphicUploadConsentAccept = () => (dispatch: Dispatch) => {
    dispatch({
        type: ActionType.graphicUploadConsent.accept,
    });
};

export {
    graphicUploadDelete,
    graphicUploadSubmit,
    graphicUploadSubmitReset,
    graphicUploadConsentAccept,
    graphicUploadSetFileCount,
};
